import React from 'react'
import ProductVariantListItem from './ProductVariantListItem'
import { VariantCategory } from '../../../../types/modules/product.type'
import SubTitle from '../../../ui/SubTitle'
import { Link, useParams } from 'react-router-dom'
import { Plus } from 'lucide-react'
import { PermissionGate } from '../../../admin/PermissionGate'
import { PermissionsKey } from '../../../../data/permissions'

type Props={
  variants:VariantCategory[],
  storeId?:number
}

function ProductVariantList({variants,storeId}:Props) {
   const { productId } = useParams<{ productId: string }>();
      const numericProductId = productId ? parseInt(productId) : 0;
  return (
    <div className=' w-[330px]'>
      <div className='flex justify-between items-center'>
                  <SubTitle title={"variants"}/>
                  <PermissionGate permissions={[PermissionsKey.UpdateProduct]}>
                    <Link to={storeId ? `/admin/stores/${storeId}/products/${numericProductId}/variants?back=true` :`/store/products/${numericProductId}/variants?back=true`}>
                        <Plus size={18} className=' text-Black'/>
                    </Link>
                  </PermissionGate>
              </div>
        {
          variants.map(variant=>{
            return <ProductVariantListItem variant={variant} key={variant.id+"variant categoryefne"}/>
          })
        }
    </div>
  )
}

export default ProductVariantList